import { Component, OnInit, EventEmitter, Input, Output, ViewChild } from "@angular/core"
import { FormGroup, FormBuilder } from "@angular/forms"
import { MatAutocompleteTrigger } from "@angular/material"
import { of } from "rxjs"
import { Observable } from "rxjs"
import { startWith, map } from "rxjs/operators"
import { HelpersService } from "src/app/services/helpers.service"
import { environment } from "src/environments/environment"

@Component({
	selector: "app-select-poi",
	templateUrl: "./select-poi.component.html",
	styleUrls: ["./select-poi.component.scss"]
})
export class SelectPoiComponent implements OnInit {
	public formGroup: FormGroup
	public elListFiltered: Observable<any[]>
	public assets_version = environment.ASSETS_VERSION
	private elList: any[] = []
	@Input() list: any[] = []
	// tslint:disable-next-line:no-output-on-prefix
	@Output() onSelected: EventEmitter<any> = new EventEmitter()
	@ViewChild(MatAutocompleteTrigger, { static: true }) _auto: MatAutocompleteTrigger

	constructor(
		private _formBuilder: FormBuilder,
		public helpersService: HelpersService
	) {}

	ngOnInit() {
		this.formGroup = this._formBuilder.group({
			elName: ""
		})
		if (this.list && this.list.length) {
			this.populateList(this.list)
		}
	}

	private populateList(list, selected = null) {
		this.elList = list
		this.elListFiltered = this.formGroup.get("elName").valueChanges.pipe(
			startWith(""),
			map(value => this._filterGroup(value))
		)
		if (selected) {
			this.formGroup.get("elName").setValue(selected.address)
			this.select(selected)
		}
	}

	private _filterGroup(value): any[] {
		if (value) {
			if (value.fullname) {
				return this.elList.filter(p => p.fullname.toLowerCase().includes(value.fullname.toLowerCase()))
			} else {
				return this.elList.filter(p => p.fullname.toLowerCase().includes(value.toLowerCase()))
			}
		}
		return this.elList
	}

	checkPoiSelected(addressPoi) {
		const options = this._auto.autocomplete.options.toArray()
		const founds = options.filter(e => e.value === addressPoi)
		if (founds.length) {
			this.formGroup.get("elName").setValue(founds[0].value)
		}
	}

	select(el) {
		this.onSelected.emit(el)
	}

	reset() {
		// this.select(null);
		this.formGroup.get("elName").setValue("")
	}
}
